import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import PageSelector from 'components/PageSelector';
import { getForumPaging } from 'selectors';
import * as actions from 'actions';

export const ForumFilteredThreadsListPageSelector = props => {
  const { query, queryString, ...otherProps } = props; //eslint-disable-line no-unused-vars
  return <PageSelector {...otherProps} />;
};

const mapStateToProps = (state, props) => {
  const { queryString } = props;
  return getForumPaging(state, 'forumThreads', { queryString });
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onPrevClick: currentPage => {
      dispatch(actions.forumThreadsFetch(currentPage - 1, props.query, props.queryString));
    },
    onNextClick: currentPage => {
      dispatch(actions.forumThreadsFetch(currentPage + 1, props.query, props.queryString));
    },
    onPossiblePageUpdate: newPossiblePage => {
      dispatch(actions.forumThreadsUpdatePossiblePage(newPossiblePage, props.queryString));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.forumThreadsFetch(newPage, props.query, props.queryString));
      }
    }
  };
};

ForumFilteredThreadsListPageSelector.propTypes = {
  query: PropTypes.object,
  queryString: PropTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumFilteredThreadsListPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumFilteredThreadsList/ForumFilteredThreadsListPageSelector/index.js
 **/